import { generatePath, createSearchParams } from 'react-router-dom';

function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var PATHS = {
    App: '/:locale/marketplace/apps',
    Service: '/:locale/marketplace/consulting-services',
    CloudsIndustry: '/:locale/marketplace/cloudsIndustry',
    Partner: '/:locale/marketplace/partner-dir',
    home: '/:locale/home',
    marketplacePartnerSuggestion: '/:locale/marketplace/partner-dir/suggestion'
};
var Products = {
    appDetails: '/:locale/product/:productId/:entityId',
    serviceDetail: '/:locale/marketplace/consulting-services/:entityId'
};
var isRoute = function(type) {
    return Object.keys(PATHS).some(function(key) {
        return key === type;
    });
};
var isProductRoute = function(type) {
    return Object.keys(Products).some(function(key) {
        return key === type;
    });
};
var isParams = function(params) {
    return (typeof params === "undefined" ? "undefined" : _type_of(params)) === 'object' && typeof params.locale === 'string';
};
var isProductParams = function(params) {
    return isParams(params) && typeof params.entityId === 'string' && typeof params.productId === 'string';
};
function appsourceRouteMatch(options) {
    var origin = window.location.origin;
    var type = options.type, params = options.params, query = options.query;
    if (!isRoute(type) && !isProductRoute(type)) {
        throw new Error('Invalid AppSource Route type');
    }
    if (!isParams(params)) {
        throw new Error('Missing locale in params');
    }
    var path;
    if (isProductRoute(type)) {
        var productPath = isProductParams(params) ? Products.appDetails : Products.serviceDetail;
        path = generatePath(productPath, params);
    } else {
        path = generatePath(PATHS[type], params);
    }
    var searchParams = createSearchParams(query);
    var url = new URL(path, origin);
    url.search = searchParams.toString();
    return url;
}
var defaultAppSourceNavigation = function(options) {
    var url = appsourceRouteMatch(options);
    window.location.href = url.toString();
};

export { appsourceRouteMatch, defaultAppSourceNavigation };
